export default __webpack_public_path__ + "static/class-0e0ab529ca34cfb64a09d536f99c8b3a.png";